///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { _escape } from '../utils';

@Pipe({
    name: 'gtthTextEscape',
    standalone: false
})
export class GtthTextEscape implements PipeTransform {
    transform(value): string {
        return _escape(value).replace(/\\/gi, '&#92;');
    }
}
